import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import './index.css';
import { applyStoredThemeEarly } from './components/ThemeToggle.js';

// Before render, so the first paint is not the wrong theme corrected a moment later.
applyStoredThemeEarly();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The data is edited by a handful of people, so aggressive refetching
      // buys little. Explicit invalidation after mutations keeps views honest.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
